// AppContext.js
import React, {
  createContext,
  useState,
  useContext,
  useRef,
  useEffect
} from 'react';
import {
  Auth,
  HOST,
  getBid
} from "./lib/Auth";

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppProvider = ({
  children
}) => {
  const [user, setUser] = useState(() => {
    
    const newSearchParams = new URLSearchParams(window.location.search);
    const fromUrl = newSearchParams.get("user");
    
    return fromUrl? JSON.parse(atob(fromUrl)) : null;
  });
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState("Open");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [chatContext, setChatContext] = useState({});
  const [chatSessionId, setChatSessionId] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState({});
  const [threads, setThreads] = useState({})
  Auth.init(user, setUser);
  const [realtimeInitialized, setRealtimeInitialized] = useState(false);
  const realtime = useRef(null)
  const bid = getBid()
  
  useEffect(()=>{
    if (!user){return}
    if (realtime.current){
      realtime.current.disconnect()
    }
    realtime.current = new window.Realtime.Realtime(`${HOST}/`, {
      reconnectionAttempts : 20,
      reconnectionDelayMax : 60000,
      auth: {
        Authorization : `Bearer ${user.token}`
      },
      /*transports: ['websocket', 'polling'],*/
      transports: ['websocket'],
      cdnBaseURL: './',
      query: {
        bid: bid,
      }
    });
    setRealtimeInitialized(true)
    realtime.current.setCurrentBusinessIds([selectedBusiness.bid]);
    realtime.current.connect()
  },[user, bid, selectedBusiness.bid])

  const value = {
    user,
    setUser,
    isLoading,
    setIsLoading,
    isProfileOpen,
    setIsProfileOpen,
    chatContext,
    setChatContext,
    chatSessionId,
    setChatSessionId,
    locations,
    setLocations,
    selectedBusiness,
    setSelectedBusiness,
    threads,
    setThreads,
    realtime,
    realtimeInitialized,
    filter, 
    setFilter
  };

  return <AppContext.Provider value = {
    value
  } > {
    children
  } < /AppContext.Provider>;
};
